import React, { useEffect, useRef } from 'react';

import { useState } from 'react';
import { useRouter } from "next/router";
import UseToast from 'hooks/use-toast';

import { userProfileNewService } from 'services/auth';
import { useQuery } from 'react-query';

import { isUserLoggedIn, getAccessToken } from 'utils/authentication';
import { publicMetaDataServices } from 'services/cv';
import Tabs from '@core/components/tabs/Tabs';
import AccountInfo from 'components/pages/settings/account/AccountInfo';
import AccountSubscription from 'components/pages/settings/account/AccountSubscription';



import classes from './DesktopAccount.module.scss';
import InterestArea from './InterestArea';
import UserInfo from './UserInfo';


const DesktopAccount = () => {
    const tabRef = useRef();
    const { toast, ToastContainer } = UseToast();
    const { data, refetch } = useQuery(
        ['user-profile-new', isUserLoggedIn(), getAccessToken()],
        userProfileNewService
    );
    const { data: certificateMetaData, refetch: refetchCertificateMetaData } = useQuery(
        ['public-profile-meta-data'],
        () => publicMetaDataServices.GET()
    );
    const tabContents = [
        {
            id: 'personal_information',
            title: 'Personal Information',
            component: <AccountInfo data={data} refetch={refetch} toast={toast} />
        },
        {
            id: 'subscription',
            title: 'Subscription',
            component: <AccountSubscription />
        }
    ];
    return (
        <>
            {data && (
                <div className='container mb-5'>
                    <div className="row">
                        <div className="col-lg-3 col-12">
                            <UserInfo
                                data={data} refetch={refetch} type="myAccount" toast={toast}
                                certificateMetaData={certificateMetaData}
                                refetchCertificateMetaData={refetchCertificateMetaData} />
                            {/* <InterestArea data={data} refetch={refetch} toast={toast} /> */}

                        </div>
                        <div className="col-lg-9 col-12">
                            <Tabs tabContents={tabContents} ref={tabRef} />
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </>
    );
};

export default DesktopAccount;